export enum SubscriptionPlanEnum {
  SinglePracticeMonthly = 'SinglePracticeMonthly',
  SinglePracticeYearly = 'SinglePracticeYearly',
  GroupPractice = 'GroupPractice'
}
